import { OpChangeState, Enums } from "../common/enums"
import { IOpData } from "../util/interfaces"
import { TypeHelper } from "../../helpers"
import { OpDataType } from "./op-data-type"
import { OpDepositoryElement } from "./op-depository-element"

export class OpDepositoryElementData implements IOpData {

    // #region Properties

    public idDepositoryElementData: number
    public idDepositoryElement: number
    public idDataType: number
    public idData: number
    public index: number
    public value: any

    // #endregion


    // #region IOpData Implementation

    public indexNBR: number
    public opState: Enums.OpChangeState

    // #endregion


    // #region Navigation Properties

    public depositoryElement: OpDepositoryElement
    public dataType: OpDataType

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // #endregion


    // #region IOpData

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idData = opObj.IdData
            this.indexNBR = opObj.IndexNBR
            this.value = opObj.Value
            this.opState = opObj.OpState
            this.idDepositoryElementData = opObj.IdDepositoryElementData
            this.idDepositoryElement = opObj.IdDepositoryElement
            this.idDataType = opObj.IdDataType
            this.index = opObj.Index
            this.depositoryElement = opObj.depositoryElement != null ? new OpDepositoryElement(opObj.DepositoryElement) : null
            this.dataType = opObj.DataType != null ? new OpDataType(opObj.DataType) : null
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            IdData: this.idData,
            IndexNBR: this.indexNBR,
            Value: this.value,
            OpState: this.opState != null ? this.opState : null,
            IdDepositoryElementData: this.idDepositoryElementData,
            IdDepositoryElement: this.idDepositoryElement,
            IdDataType: this.idDataType,
            Index: this.index,
            DepositoryElement: this.depositoryElement,
            DataType: this.dataType,
        }
    }

    // #endregion
}

